module.exports = __webpack_public_path__ + "img/2A2A2A_B3B3B3_6D6D6D_848C8C-256px.e190c893.png";